module.exports = __webpack_public_path__ + "static/media/h2.a07d9637.svg";